// src/components/dialog/DlgPanelPresentationLevel.tsx

import {
  Button,
  Card,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material'

import { KARMA_WizardDialog } from '@/types/karma/dialog'

import { DlgCloseButton } from './DlgCloseButton'

const options = [
  {
    label: 'Gebäudeebene',
    description:
      'In der Gebäudeebene werden alle ausgewählten Messpunkte unter dem Gebäudenamen gebündelt.',
    value: 1,
  },
  {
    label: 'Messpunktebene',
    description:
      'In der Messpunktebene werden alle ausgewählten Messpunkte einzeln aufgelistet.',
    value: 2,
  },
]

type DlgPanelPresentationLevelProps = KARMA_WizardDialog & {
  data: number
  onChange: (presentationLevel: number) => void
}

export const DlgPanelPresentationLevel = ({
  data,
  onChange,
  onClose,
  onGotoNext,
  onGotoPrev,
  open,
}: DlgPanelPresentationLevelProps) => (
  <Dialog fullWidth maxWidth={'xl'} open={open}>
    <DialogTitle>
      <Typography>Neue Kachel</Typography>

      <DlgCloseButton onClick={onClose} />
    </DialogTitle>

    <DialogContent sx={{ my: 1 }}>
      <FormControl sx={{ my: 2 }}>
        <RadioGroup
          onChange={event => {
            const presentation_level = Number(event.target.value)
            onChange(presentation_level)
          }}
          row
          sx={{ gap: 2, width: '100%', justifyContent: 'center' }}
          value={data}
        >
          {options.map(item => (
            <Card
              key={item.value}
              variant={'outlined'}
              sx={{
                flex: 1,
                textAlign: 'center',
                p: 2,
                cursor: 'pointer',
                borderRadius: 2,
                borderColor: data === item.value ? 'primary.main' : 'grey.300',
                boxShadow: data === item.value ? 3 : 0,
                '&:hover': { borderColor: 'primary.main' },
              }}
            >
              <CardContent>
                <Typography variant={'h6'} gutterBottom>
                  {item.label}
                </Typography>
                <Typography variant={'body2'} color={'text.secondary'}>
                  {item.description}
                </Typography>
                <Radio
                  checked={data === Number(item.value)}
                  sx={{ mt: 2 }}
                  value={item.value}
                />
              </CardContent>
            </Card>
          ))}
        </RadioGroup>
      </FormControl>
    </DialogContent>

    <DialogActions>
      <Button onClick={onGotoPrev}>Zurück</Button>
      <Button onClick={onGotoNext}>Weiter</Button>
    </DialogActions>
  </Dialog>
)
